export default "__VITE_ASSET__MlxqlkJC__"